// PRODUCTION
const SHARGO_URL = 'https://api.shargo.io/v1/'
const SHARGO_API =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOiI1YjFlNTkxYTVhYzQ2YjBmMDBjNjVjNzQiLCJpYXQiOjE1Mjg3MTYyMzYsImV4cCI6MTYyMzMyNDIzNn0.tWBx-VvpP0QG23evrSScOQITSmcAKAhvsu29JHqygPE'
// DEVELOPMENT
// const SHARGO_URL = 'https://api-sandbox.shargo.io/v1/'
// const SHARGO_API = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOiI1YWRlZTg4ZGMyMjI5ODEwMDBkYTIzMDAiLCJpYXQiOjE1MjQ1NTc5NjYsImV4cCI6MTYxOTE2NTk2Nn0.6JSC_rVCzqZHKe6igJJ7LjHLgMNGNa-yTMN_z-L_Ha0'
export default {
  companyName: 'FRUTOS ROJOS',
  headerColor: '#55a885',
  address: 'C/ SOT DE LES VERNEDES 2<br>08396 SANT CEBRIÀ DE VALLALTA',
  location: {
    url: 'https://goo.gl/maps/MaMfx4CBvnNN4xYC9',
    lat: 41.610409,
    lng: 2.6006365,
  },
  firebase: {
    apiKey: 'AIzaSyAVUlKz2Bl2Z3HvxeXgnsEWSv2YqtrcwTY',
    authDomain: 'frutosrojos-delivery.firebaseapp.com',
    databaseURL: 'https://frutosrojos-delivery.firebaseio.com',
    projectId: 'frutosrojos-delivery',
    storageBucket: 'frutosrojos-delivery.appspot.com',
    messagingSenderId: '718031732617',
    appId: '1:718031732617:web:270f2195ea2cdfd487eb58',
    measurementId: 'G-H4Y95203M4',
  },
  baseApiUrl: SHARGO_URL,
  headers: {
    Authorization: SHARGO_API,
    'Content-Type': 'application/json',
  },
  codPostales: [
    '08395',
    '08370',
    '08397',
    '08380',
    '08398',
    '08396',
    '08359',
    '08360',
    '08350',
    '08358',
    '08393',
    '08392',
    '08394',
    '08328',
    '08310',
    '08349',
    '08339',
    '08340',
    '08338',
    '08330',
    '08301',
    '08302',
    '08303',
    '08304',
    '08860',
    '08921',
    '08922',
    '08923',
    '08924',
    '08950',
    '08911',
    '08912',
    '08913',
    '08914',
    '08915',
    '08916',
    '08917',
    '08918',
    '08901',
    '08902',
    '08903',
    '08904',
    '08905',
    '08906',
    '08907',
    '08908',
    '08172',
    '08173',
    '08174',
    '08190',
    '08195',
    '08196',
    '08197',
    '08198',
    '08193',
    '08290',
    '08401',
    '08402',
    '08403',
    '08201',
    '08202',
    '08203',
    '08204',
    '08205',
    '08206',
    '08207',
    '08208',
    '08161',
    '08191',
    '08221',
    '08222',
    '08223',
    '08224',
    '08225',
    '08226',
    '08227',
    '08228',
    '08001',
    '08002',
    '08003',
    '08004',
    '08005',
    '08006',
    '08007',
    '08008',
    '08009',
    '08010',
    '08011',
    '08012',
    '08013',
    '08014',
    '08015',
    '08016',
    '08017',
    '08018',
    '08019',
    '08020',
    '08021',
    '08022',
    '08023',
    '08024',
    '08025',
    '08026',
    '08027',
    '08028',
    '08029',
    '08030',
    '08031',
    '08032',
    '08033',
    '08034',
    '08035',
    '08036',
    '08037',
    '08038',
    '08039',
    '08040',
    '08041',
    '08042',
    '08960',
    '08980',
    '08840'
  ],
}
